module.exports = __webpack_public_path__ + "images/corners/Monterystep.4a0fb1faf2b6a6b38b5d09e02d955050.jpg";